<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <ul class="items-center gap-x-3 flex">
        <el-form-item
          label="金额"
          prop="amount"
          :rules="[{ required: true, message: '请输入金额', trigger: 'blur' }]"
        >
          <el-input-number
            v-model="state.model.amount"
            class="number-input-left number-input-suffix !w-full"
            precision="2"
            suffix="元"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="付款方式">
          <el-select
            v-model="state.model.d_payment_type_id"
            :empty-values="[null, undefined, 0]"
            class="!w-56"
          >
            <el-option
              v-for="item in state.fkfs_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </ul>
      <el-form-item
        label="收款账户"
        prop="supplier_bank_account_id"
        :rules="[
          {
            required: true,
            message: '请选择收款账户收款账户',
            trigger: 'blur',
          },
        ]"
      >
        <el-select v-model="state.model.supplier_bank_account_id" filterable>
          <template #label="{ value }">
            <div
              v-if="zh_map.get(value)"
              class="grid w-full gap-x-10 items-center"
              style="grid-template-columns: 1fr auto"
            >
              <text>{{ zh_map.get(value).opening_bank }}</text>
              <text class="text-gray-400 text-xs">
                {{ zh_map.get(value).name + "-" + zh_map.get(value).account }}
              </text>
            </div>
          </template>
          <el-option
            v-for="item in state.zh_data"
            :key="item.id"
            :label="`${item.opening_bank} ${item.name} ${item.account}`"
            :value="item.id"
          >
            <div
              class="grid w-full gap-x-10 items-center"
              style="grid-template-columns: 1fr auto"
            >
              <text>{{ item.opening_bank }}</text>
              <text class="text-gray-400 text-xs">
                {{ item.name + "-" + item.account }}
              </text>
            </div>
          </el-option>
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadZh()"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="申请说明">
        <el-input
          v-model="state.model.intro"
          type="textarea"
          :autosize="{
            minRows: 3,
          }"
        ></el-input>
      </el-form-item>
      <ul class="grid grid-cols-3 gap-x-3">
        <el-form-item
          label="财务审批"
          prop="cfo"
          :rules="[
            { required: true, message: '请选择财务审批人', trigger: 'blur' },
          ]"
        >
          <c_userselect v-model="state.model.cfo" class="!w-60" :type="2" />
        </el-form-item>
        <el-form-item
          label="总经理审批"
          prop="ceo"
          :rules="[
            { required: true, message: '请选择总经理审批人', trigger: 'blur' },
          ]"
        >
          <c_userselect v-model="state.model.ceo" class="!w-60" :type="3" />
        </el-form-item>
        <el-form-item
          label="付款出纳"
          prop="cashier_admin_id"
          :rules="[
            { required: true, message: '请选择付款出纳', trigger: 'blur' },
          ]"
        >
          <c_userselect
            v-model="state.model.cashier_admin_id"
            class="!w-60"
            :type="4"
            @change:item="
              (item) => {
                state.model.cashier_department_id = item.department_id;
              }
            "
          />
        </el-form-item>
      </ul>
      <el-form-item label="附件">
        <c_UploadFile
          class="!w-full"
          :value="state.model.files"
          @change="
            (data) => {
              state.model.files = data;
            }
          "
        />
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue";
import { dic_getPaymentType, data_getSupplierBankAccount } from "@/http/data";
import { supplier_payment_apply_add } from "@/http/supplier";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    supplier_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        supplier_id: props.supplier_id,
      },
    });
    onMounted(() => {
      onLoadFkfs();
      onLoadZh();
    });

    //获取付款方式
    const onLoadFkfs = () => {
      dic_getPaymentType().then((res) => {
        if (res.status == 200) state.fkfs_data = res.data.data;
      });
    };

    //获取供应商账户
    const onLoadZh = () => {
      data_getSupplierBankAccount({
        supplier_id: props.supplier_id,
      }).then((res) => {
        if (res.status == 200) state.zh_data = res.data.data?.list || [];
      });
    };

    //供应商账户 id 索引，O(1) 查找
    const zh_map = computed(() => {
      const m = new Map();
      state.zh_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.attachment = JSON.stringify(
            state.model.files?.map((m) => m.id),
          );
          supplier_payment_apply_add(state.model).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      zh_map,
      onSubmit,
      onLoadZh,
      onLoadFkfs,
    };
  },
};
</script>
<style scoped></style>
